import React, { useState, useMemo, useEffect } from "react";
import { View, ScrollView, Text, TouchableOpacity, Modal } from "react-native";
import { useDispatch } from "react-redux";
import { fullDataPiece } from "../../services/ConnectDataBase.js";
import { SCREEN_IDS } from "../FullComponent.js";
import { typeConnect } from "../../constants/Constants";
import { getFullUsuarios } from "../../services/ConnectDataBase";
import { getTimeForTeam } from "../../services/LogicaCargaDeFabrica.js";
import { getTiemposMo } from "../../services/ConnectDataBase";
import { styles } from "../../style/FoundryStyle.js";
import { tiposPiezas } from "../../constants/Constants";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { updateInfoData } from "../../redux/reducers";
import calendarioLaboral from "../../services/calendarioLaboral.json";
import { translateText } from "../../translations/translationService";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { 
  BRAND_COLORS, 
  BACKGROUND_COLORS, 
  TEXT_COLORS, 
  BORDER_COLORS, 
  SHADOW_COLORS,
  COMPONENT_COLORS,
  CALCULO_CARGA_COLORS 
} from "../../style/colors.js";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  teamRows: 6,           // Número de filas de equipos
  dateColumns: 20,        // Número de columnas de fechas a mostrar (de 183 totales)
  height: 20,            // Altura de los skeletons en px
  widthLabel: "100%",    // Ancho del skeleton de etiqueta
  widthValue: "100%",    // Ancho del skeleton de valor
};

const normalizeCalendarDate = (rawDate) => {
  if (!rawDate || typeof rawDate !== "string") return null;
  const value = rawDate.trim();
  if (!value) return null;

  // API suele devolver DD-MM-YYYY (campo FECHA).
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [day, month, year] = value.split("-");
    return `${year}-${month}-${day}`;
  }

  // Soporte extra si en algún entorno llega YYYY-MM-DD.
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  return null;
};

const getApiNonWorkingDays = (calendarFromApi) => {
  if (!Array.isArray(calendarFromApi)) return [];
  return calendarFromApi
    .map((day) => normalizeCalendarDate(day?.FECHA))
    .filter(Boolean);
};

const calculateDates = (nonWorkingDaysSet) => {
  const dates = [];
  const today = new Date();

  for (let i = 1; i <= 183; i++) {
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + i);
    const formattedDate = `${String(nextDate.getDate()).padStart(
      2,
      "0"
    )}/${String(nextDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${nextDate.getFullYear()}`;
    const isoDate = nextDate.toISOString().split("T")[0];

    const isNonWorkingDay =
      nonWorkingDaysSet.has(isoDate) ||
      nextDate.getDay() === 0 ||
      nextDate.getDay() === 6;

    dates.push({
      date: formattedDate,
      day: nextDate.getDay(),
      isNonWorkingDay,
    });
  }

  return dates;
};

const CalculoCargaDeFabrica = ({ navigation }) => {
  const dispatch = useDispatch();
  const currentScreenId = SCREEN_IDS.FACTORY_LOAD;
  const lang = useSelector((state) => state.lang.value);
  const calendarioApi = useSelector((state) => state.calendario);
  const userQuery = "userQuery";
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMOs, setModalMOs] = useState([]);
  const [equipos, setEquipos] = useState([]);
  const [arrayFullDatos, setArrayFullDatos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const nonWorkingDaysSet = useMemo(() => {
    const localDays = Array.isArray(calendarioLaboral?.nonWorkingDays)
      ? calendarioLaboral.nonWorkingDays
      : [];
    const apiDays = getApiNonWorkingDays(calendarioApi);
    return new Set([...localDays, ...apiDays]);
  }, [calendarioApi]);
  const headers = useMemo(() => calculateDates(nonWorkingDaysSet), [nonWorkingDaysSet]);

  useEffect(() => {
    console.log("Fetching data...");
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const listaOperarios = await getFullUsuarios(
          SCREEN_IDS.INFO_DIARIO,
          typeConnect[0],
          userQuery
        );
        const tiemposTeam = await getTimeForTeam(listaOperarios);
        setEquipos(
          tiemposTeam.map((team) => ({
            nombre: team.team,
            capacidadMax: team.minutes,
            dias: Array(183).fill(0),
          }))
        );
        const tiemposMoActivas = await getTiemposMo(
          currentScreenId,
          typeConnect[0],
          userQuery
        );
        setArrayFullDatos(unificarArray(tiemposMoActivas, tiposPiezas));
      } catch (error) {
        console.error("Error cargando datos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCellPress = (mos) => {
    setModalMOs(mos);
    setModalVisible(true);
  };

  const getCellStyle = (cargaUsada, capacidadMax, isNonWorkingDay) => {
    if (isNonWorkingDay) {
      return { backgroundColor: CALCULO_CARGA_COLORS.NON_WORKING_DAY, color: TEXT_COLORS.BLACK };
    }

    const porcentaje = (cargaUsada / capacidadMax) * 100;

    let backgroundColor = BACKGROUND_COLORS.CARD;
    let color = TEXT_COLORS.BLACK;

    if (porcentaje > 80) {
      backgroundColor = BRAND_COLORS.ACCENT;
      color = TEXT_COLORS.LIGHT;
    } else if (porcentaje > 60) {
      backgroundColor = BRAND_COLORS.PRIMARY;
      color = TEXT_COLORS.LIGHT;
    } else if (porcentaje > 40) {
      backgroundColor = CALCULO_CARGA_COLORS.PRIMARY_LIGHT;
      color = TEXT_COLORS.DARK;
    } else if (porcentaje > 20) {
      backgroundColor = CALCULO_CARGA_COLORS.MEDIUM_LOAD;
      color = TEXT_COLORS.DARK;
    } else if (porcentaje > 0) {
      backgroundColor = CALCULO_CARGA_COLORS.LOW_LOAD;
      color = TEXT_COLORS.DARK;
    }

    return { backgroundColor, color };
  };

  const unificarArray = (data, tipoPiezas) => {
    const result = [];

    data.forEach((item) => {
      const tipoOrdenLimpio = item.tipo_orden.trim().replace(/\s+/g, " ");
      const existingEntry = result.find((entry) => entry.mo === item.mo);
      const tipoPiezaMatch = tipoPiezas.find(
        (pieza) => pieza.name.trim().replace(/\s+/g, " ") === tipoOrdenLimpio
      );

      if (
        (!item.tipo_proceso || item.tipo_proceso.trim() === "") &&
        /^[\w\d]{7,8}$/.test(item.codigo)
      ) {
        item.tipo_proceso = "PIEDRAS";
      } else {
        item.tipo_proceso = item.tipo_proceso.trim();
      }

      if (existingEntry) {
        existingEntry.detalles.push({
          tipo_proceso: item.tipo_proceso,
          tiempo_teorico: item.tiempo_teorico,
          codigo: item.codigo,
        });

        if (tipoPiezaMatch && !existingEntry.days) {
          existingEntry.days = tipoPiezaMatch.days;
        }
      } else {
        const newEntry = {
          mo: item.mo,
          fechaentrega: item.fechaentrega,
          tipo_orden: item.tipo_orden,
          cantidad_pendiente: item.cantidad_pendiente,
          detalles: [
            {
              tipo_proceso: item.tipo_proceso,
              tiempo_teorico: item.tiempo_teorico,
              codigo: item.codigo,
            },
          ],
        };

        if (tipoPiezaMatch) {
          newEntry.days = tipoPiezaMatch.days;
        }

        result.push(newEntry);
      }
    });

    result.forEach((entry) => {
      const cantidadPendiente = parseFloat(entry.cantidad_pendiente);

      entry.detalles = entry.detalles.map((detalle) => {
        const tiempoTeorico = parseFloat(detalle.tiempo_teorico);
        const cargaTrabajo = parseFloat(
          (cantidadPendiente * tiempoTeorico).toFixed(2)
        );
        return {
          ...detalle,
          carga_trabajo: cargaTrabajo,
        };
      });

      if (entry.days && entry.fechaentrega.date) {
        const fechaEntrega = new Date(entry.fechaentrega.date);

        if (!isNaN(fechaEntrega.getTime())) {
          const fechaInicio = new Date(
            fechaEntrega.setDate(fechaEntrega.getDate() - entry.days)
          );
          entry.fecha_inicio = fechaInicio.toISOString().split("T")[0];
        } else {
          console.error("Fecha de entrega no válida:", entry.fechaentrega);
        }
      }
    });

    result.sort((a, b) => {
      const dateA = new Date(a.fechaentrega);
      const dateB = new Date(b.fechaentrega);
      return dateA - dateB;
    });

    return result;
  };

  const modificarDatosPorLogica = (mo) => {
    let fechaInicioEngastado = null;
    let fechaInicioPulido = null;
    let fechaInicioBaños = null;
    let fechaInicioCalidad = null;

    setEquipos((prevEquipos) =>
      prevEquipos.map((equipo) => {
        const newDias = [...equipo.dias];
        const moDias = [...(equipo.moDias || Array(183).fill([]))];

        mo.detalles.forEach((detalle) => {
          const verificarDiaLaboral = (currentDate, index) =>
            !headers[index].isNonWorkingDay;

          if (
            detalle.tipo_proceso === "REPASO" &&
            equipo.nombre === "Sacador de fuego" &&
            mo.tipo_orden !== "Fabricacion Mixta"
          ) {
            let totalCargaRepaso = detalle.carga_trabajo;
            const fechaInicio = new Date(mo.fecha_inicio);
            let fechaFinRepaso = null;
            headers.forEach((header, index) => {
              const currentDate = new Date(
                header.date.split("/").reverse().join("-")
              );
              if (
                currentDate >= fechaInicio &&
                totalCargaRepaso > 0 &&
                verificarDiaLaboral(currentDate, index)
              ) {
                const capacidadRestante = equipo.capacidadMax - newDias[index];
                const minutosAsignar = Math.min(
                  capacidadRestante,
                  totalCargaRepaso
                );
                if (minutosAsignar > 0) {
                  newDias[index] += minutosAsignar;
                  moDias[index] = [...moDias[index], mo.mo];
                  totalCargaRepaso -= minutosAsignar;
                  newDias[index] = parseFloat(newDias[index].toFixed(2));
                  fechaFinRepaso = currentDate;
                  if (totalCargaRepaso <= 0) return;
                }
              }
            });

            if (fechaFinRepaso) {
              detalle.fecha_fin_repaso = fechaFinRepaso
                .toISOString()
                .split("T")[0];
              fechaInicioEngastado = new Date(fechaFinRepaso);
              fechaInicioEngastado.setDate(fechaInicioEngastado.getDate() + 1);
            }
          }

          if (
            detalle.tipo_proceso === "PIEDRAS" &&
            equipo.nombre === "Engastado"
          ) {
            if (fechaInicioEngastado) {
              fechaInicioEngastado = new Date(fechaInicioEngastado);
            } else {
              fechaInicioEngastado = new Date(mo.fecha_inicio || new Date());
            }

            let totalCargaEngastado = detalle.carga_trabajo;
            let fechaFinEngastado = null;
            headers.forEach((header, index) => {
              const currentDate = new Date(
                header.date.split("/").reverse().join("-")
              );
              if (
                currentDate >= fechaInicioEngastado &&
                totalCargaEngastado > 0 &&
                verificarDiaLaboral(currentDate, index)
              ) {
                const capacidadRestante = equipo.capacidadMax - newDias[index];
                const minutosAsignar = Math.min(
                  capacidadRestante,
                  totalCargaEngastado
                );
                if (minutosAsignar > 0) {
                  newDias[index] += minutosAsignar;
                  moDias[index] = [...moDias[index], mo.mo];
                  totalCargaEngastado -= minutosAsignar;
                  newDias[index] = parseFloat(newDias[index].toFixed(2));
                  fechaFinEngastado = currentDate;
                  if (totalCargaEngastado <= 0) return;
                }
              }
            });

            if (fechaFinEngastado) {
              detalle.fecha_fin_engastado = fechaFinEngastado
                .toISOString()
                .split("T")[0];
              fechaInicioPulido = new Date(fechaFinEngastado);
              fechaInicioPulido.setDate(fechaInicioPulido.getDate() + 1);
            }
          }

          if (detalle.tipo_proceso === "PULIDO" && equipo.nombre === "Pulido") {
            if (!fechaInicioPulido) {
              fechaInicioPulido = new Date(
                fechaInicioEngastado || mo.fecha_inicio || new Date()
              );
            }

            let totalCargaPulido = detalle.carga_trabajo;
            let fechaFinPulido = null;

            headers.forEach((header, index) => {
              const currentDate = new Date(
                header.date.split("/").reverse().join("-")
              );
              if (
                currentDate >= fechaInicioPulido &&
                totalCargaPulido > 0 &&
                verificarDiaLaboral(currentDate, index)
              ) {
                const capacidadRestante = equipo.capacidadMax - newDias[index];
                const minutosAsignar = Math.min(
                  capacidadRestante,
                  totalCargaPulido
                );
                if (minutosAsignar > 0) {
                  newDias[index] += minutosAsignar;
                  moDias[index] = [...moDias[index], mo.mo];
                  totalCargaPulido -= minutosAsignar;
                  newDias[index] = parseFloat(newDias[index].toFixed(2));
                  fechaFinPulido = currentDate;
                  if (totalCargaPulido <= 0) return;
                }
              }
            });

            if (fechaFinPulido) {
              detalle.fecha_fin_pulido = fechaFinPulido
                .toISOString()
                .split("T")[0];
              fechaInicioBaños = new Date(fechaFinPulido);
              fechaInicioBaños.setDate(fechaInicioBaños.getDate() + 1);
            }
          }

          if (detalle.tipo_proceso === "BAÑOS" && equipo.nombre === "Baños") {
            if (!fechaInicioBaños) {
              fechaInicioBaños = new Date(
                fechaInicioPulido || mo.fecha_inicio || new Date()
              );
            }

            let totalCargaBaños = detalle.carga_trabajo;
            let fechaFinBaños = null;

            headers.forEach((header, index) => {
              const currentDate = new Date(
                header.date.split("/").reverse().join("-")
              );
              if (
                currentDate >= fechaInicioBaños &&
                totalCargaBaños > 0 &&
                verificarDiaLaboral(currentDate, index)
              ) {
                const capacidadRestante = equipo.capacidadMax - newDias[index];
                const minutosAsignar = Math.min(
                  capacidadRestante,
                  totalCargaBaños
                );
                if (minutosAsignar > 0) {
                  newDias[index] += minutosAsignar;
                  moDias[index] = [...moDias[index], mo.mo];
                  totalCargaBaños -= minutosAsignar;
                  newDias[index] = parseFloat(newDias[index].toFixed(2));
                  fechaFinBaños = currentDate;
                  if (totalCargaBaños <= 0) return;
                }
              }
            });

            if (fechaFinBaños) {
              detalle.fecha_fin_baños = fechaFinBaños
                .toISOString()
                .split("T")[0];
              fechaInicioCalidad = new Date(fechaFinBaños);
              fechaInicioCalidad.setDate(fechaInicioCalidad.getDate() + 1);
            }
          }

          if (
            (detalle.tipo_proceso === "CALIDAD" &&
              equipo.nombre === "Control de calidad") ||
            equipo.nombre === "Jefe de taller"
          ) {
            if (!fechaInicioCalidad) {
              fechaInicioCalidad = new Date(
                fechaInicioBaños ||
                  fechaInicioPulido ||
                  mo.fecha_inicio ||
                  new Date()
              );
            }

            let totalCargaCalidad = detalle.carga_trabajo;

            headers.forEach((header, index) => {
              const currentDate = new Date(
                header.date.split("/").reverse().join("-")
              );
              if (
                currentDate >= fechaInicioCalidad &&
                totalCargaCalidad > 0 &&
                verificarDiaLaboral(currentDate, index)
              ) {
                const capacidadRestante = equipo.capacidadMax - newDias[index];
                const minutosAsignar = Math.min(
                  capacidadRestante,
                  totalCargaCalidad
                );
                if (minutosAsignar > 0) {
                  newDias[index] += minutosAsignar;
                  moDias[index] = [...moDias[index], mo.mo];
                  totalCargaCalidad -= minutosAsignar;
                  newDias[index] = parseFloat(newDias[index].toFixed(2));
                }
              }
            });
          }
        });

        return { ...equipo, dias: newDias, moDias };
      })
    );
  };

  const validateData = async (code) => {
    if (!code) {
      return;
    }
    try {
      const dataOk = await fullDataPiece(code.mo, 2);
      if (dataOk) {
        const infoData = getArrayInfoDataUpdate(dataOk);

        dispatch(updateInfoData(infoData));
        return dataOk;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitCode = async (mo) => {
    try {
      const fullData = await validateData({ mo });
      if (fullData && fullData.mo) {
        setModalVisible(false);
        navigation.navigate("Info", { data: fullData });
      } else {
        console.log("No se encontró la propiedad 'mo' en fullData.");
      }
    } catch (error) {
      console.error("Error al procesar la MO:", error);
    }
  };

  useEffect(() => {
    arrayFullDatos.forEach((mo) => {
      modificarDatosPorLogica(mo);
    });
  }, [arrayFullDatos]);

  if (isLoading) {
    return (
      <View style={styles.containerRepairScreen}>
        <View style={styles.tableRepairScreen}>
          <TableContainer
            component={Paper}
            style={{
              ...styles.tableContainerRepairScreen,
              height: "calc(110% - 20px)",
            }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      ...styles.headerCellRepairScreen,
                      borderBottom: "1px solid #9bb1bb",
                      padding: "2px 4px",
                      backgroundColor: BACKGROUND_COLORS.DARK,
                    }}>
                    <View style={{ display: "flex", alignItems: "center" }}>
                      <Skeleton variant="text" width={80} height={20} sx={{ bgcolor: "rgba(255,255,255,0.3)" }} />
                    </View>
                  </TableCell>
                  <TableCell
                    style={{
                      ...styles.headerCellRepairScreen,
                      borderBottom: "1px solid #9bb1bb",
                      padding: "2px 4px",
                      backgroundColor: BACKGROUND_COLORS.DARK,
                      textAlign: "center",
                    }}>
                    <View style={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="text" width={60} height={20} sx={{ bgcolor: "rgba(255,255,255,0.3)" }} />
                    </View>
                  </TableCell>
                  {headers.slice(0, SKELETON_CONFIG.dateColumns).map((header, index) => (
                    <TableCell
                      key={index}
                      style={{
                        ...styles.headerCellRepairScreen,
                        borderBottom: "1px solid #9bb1bb",
                        padding: "2px 6px",
                        backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                      }}>
                      <View style={{ display: "flex", justifyContent: "center" }}>
                        <Skeleton variant="text" width={60} height={16} />
                      </View>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {[...Array(SKELETON_CONFIG.teamRows)].map((_, teamIndex) => (
                  <TableRow 
                    key={teamIndex}
                    style={{
                      ...styles.rowRepairScreen,
                      backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                    }}>
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 8px",
                        backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                        borderBottom: "1px solid #9bb1bb",
                      }}>
                      <Skeleton variant="text" width={SKELETON_CONFIG.widthLabel} height={SKELETON_CONFIG.height} />
                    </TableCell>
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 4px",
                        backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                        borderBottom: "1px solid #9bb1bb",
                        textAlign: "center",
                      }}>
                      <View style={{ display: "flex", justifyContent: "center" }}>
                        <Skeleton variant="text" width={40} height={SKELETON_CONFIG.height} />
                      </View>
                    </TableCell>
                    {[...Array(SKELETON_CONFIG.dateColumns)].map((_, diaIndex) => (
                      <TableCell
                        key={diaIndex}
                        style={{
                          ...styles.cellRepairScreen,
                          padding: "2px 6px",
                          backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          borderBottom: "1px solid #9bb1bb",
                          textAlign: "center",
                        }}>
                        <View style={{ display: "flex", justifyContent: "center" }}>
                          <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                        </View>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.containerRepairScreen}>
      <View style={styles.tableRepairScreen}>
        <TableContainer
          component={Paper}
          style={{
            ...styles.tableContainerRepairScreen,
            height: "calc(110% - 20px)",
          }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    borderBottom: "1px solid #9bb1bb",
                    padding: "2px 4px",
                    backgroundColor: BACKGROUND_COLORS.DARK,
                  }}>
                  <Text style={{ fontWeight: "500", fontSize: 15, color: TEXT_COLORS.LIGHT }}>
                    {translateText("Equipo", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    borderBottom: "1px solid #9bb1bb",
                    padding: "2px 4px",
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", fontSize: 15, color: TEXT_COLORS.LIGHT }}>Cap. Max.</Text>
                </TableCell>
                {headers.map((header, index) => (
                  <TableCell
                    key={index}
                    style={{
                      ...styles.headerCellRepairScreen,
                      borderBottom: "1px solid #9bb1bb",
                      padding: "2px 6px",
                      backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                    }}>
                    <Text style={{ fontWeight: "500", fontSize: 14, color: "#174045" }}>{header.date}</Text>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {equipos.map((equipo, teamIndex) => (
                <TableRow 
                  style={{
                    ...styles.rowRepairScreen,
                    backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                  }} 
                  key={teamIndex}>
                  <TableCell
                    style={{
                      ...styles.cellRepairScreen,
                      padding: "2px 8px",
                      backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      borderBottom: "1px solid #9bb1bb",
                    }}>
                    <Text style={{ fontSize: 15, fontWeight: "500", color: "#174045" }}>
                      {equipo.nombre === "Sacador de fuego"
                        ? "Repaso"
                        : equipo.nombre === "Control de calidad"
                        ? "Calidad"
                        : equipo.nombre}
                    </Text>
                  </TableCell>
                  <TableCell
                    style={{
                      ...styles.cellRepairScreen,
                      padding: "2px 4px",
                      backgroundColor: teamIndex % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      borderBottom: "1px solid #9bb1bb",
                      textAlign: "center",
                    }}>
                    <Text style={{ fontSize: 15, color: "#174045" }}>{equipo.capacidadMax}</Text>
                  </TableCell>

                  {equipo.dias.map((dia, diaIndex) => {
                    const { backgroundColor, color } = getCellStyle(
                      dia,
                      equipo.capacidadMax,
                      headers[diaIndex].isNonWorkingDay
                    );

                    const cellContent = headers[diaIndex].isNonWorkingDay
                      ? " "
                      : dia;
                    return (
                      <TableCell
                        key={diaIndex}
                        style={{
                          ...styles.cellRepairScreen,
                          padding: "2px 6px",
                          backgroundColor,
                          color,
                          borderBottom: "1px solid #9bb1bb",
                          textAlign: "center",
                        }}>
                        <TouchableOpacity
                          onPress={() =>
                            handleCellPress(equipo.moDias[diaIndex])
                          }>
                          <Text style={{ color, fontSize: 14 }}>{cellContent}</Text>
                        </TouchableOpacity>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Modal
            animationType='fade'
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => setModalVisible(false)}>
            <View style={styles.modalContainer}>
              <View
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: 6,
                  width: "90%",
                  maxWidth: 500,
                  maxHeight: "70%",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.1,
                  shadowRadius: 4,
                  elevation: 5,
                  borderWidth: 1,
                  borderColor: "#9bb1bb",
                  overflow: "hidden",
                }}>
                {/* Header */}
                <View
                  style={{
                    backgroundColor: "#f5f5f5",
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                    borderBottomWidth: 1,
                    borderBottomColor: "#9bb1bb",
                  }}>
                  <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <Text
                      style={{
                        fontSize: 17,
                        fontWeight: "600",
                        color: "#174045",
                        flex: 1,
                      }}>
                      {translateText("MOs asignadas a este día", lang)}
                    </Text>
                    <TouchableOpacity
                      style={{
                        padding: 2,
                      }}
                      onPress={() => setModalVisible(false)}>
                      <Text style={{ fontSize: 18, color: "#666", fontWeight: "300" }}>×</Text>
                    </TouchableOpacity>
                  </View>
                </View>

                {/* Content */}
                <View
                  style={{
                    flex: 1,
                    padding: 12,
                  }}>
                  {modalMOs.length > 0 ? (
                    <ScrollView
                      style={{ flex: 1 }}
                      showsVerticalScrollIndicator={false}>
                      {modalMOs.map((mo, index) => (
                        <TouchableOpacity
                          key={index}
                          style={{
                            backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                            borderRadius: 4,
                            marginBottom: index === modalMOs.length - 1 ? 0 : 6,
                            borderWidth: 1,
                            borderColor: "#9bb1bb",
                            overflow: "hidden",
                          }}
                          onPress={() => handleSubmitCode(mo)}
                          activeOpacity={0.7}>
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 8,
                            }}>
                            <Text
                              style={{
                                fontSize: 16,
                                fontWeight: "500",
                                color: "#174045",
                                flex: 1,
                                fontFamily: "monospace",
                              }}>
                              {mo}
                            </Text>
                            <Text
                              style={{
                                fontSize: 16,
                                color: "#174045",
                                fontWeight: "500",
                              }}>
                              →
                            </Text>
                          </View>
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  ) : (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        paddingVertical: 40,
                      }}>
                      <Text
                        style={{
                          fontSize: 16,
                          color: "#666",
                          textAlign: "center",
                          fontWeight: "500",
                        }}>
                        {translateText("No hay MOs asignadas", lang)}
                      </Text>
                    </View>
                  )}
                </View>

                {/* Footer */}
                <View
                  style={{
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                    borderTopWidth: 1,
                    borderTopColor: "#9bb1bb",
                    backgroundColor: "#ffffff",
                  }}>
                  <TouchableOpacity
                    style={{
                      backgroundColor: "#174045",
                      borderRadius: 4,
                      paddingVertical: 8,
                      paddingHorizontal: 16,
                      alignItems: "center",
                    }}
                    onPress={() => setModalVisible(false)}
                    activeOpacity={0.8}>
                    <Text
                      style={{
                        color: "#ffffff",
                        fontSize: 15,
                        fontWeight: "500",
                        textTransform: "uppercase",
                      }}>
                      {translateText("Cerrar", lang)}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Modal>
        </TableContainer>
      </View>
    </View>
  );
};

export default CalculoCargaDeFabrica;
